import Service from "../../AuthService";

const SaveExportation = {
    getSaveExportation(page) {
        return Service.get("/save_exportation?page="+page);
    },
    showSaveExportation(id) {
        return Service.get("/save_exportation/" + id);
    },
    updateSaveExportation(id, data) {
        return Service.post("/save_exportation/" + id, data);
    },
    createSaveExportation(data) {
        return Service.post("/save_exportation", data);
    },
    deleteSaveExportation(id) {
        return Service.delete("/save_exportation/" + id);
    },
    searchSaveExportation(data){
        return Service.post('/save_exportation_search',data);
    },
    getInvoiceByDriver(){
        return Service.get("/invoice_by_driver");
    }
};

export default SaveExportation;

